<template>
	<v-chip v-if="info" x-small :color="info.level === 'late' ? 'error' : 'warning'" :title="title" class="late-badge">
		<v-icon x-small left>mdi-timer-alert-outline</v-icon>{{ label }}
	</v-chip>
</template>

<script>
// badge "in ritardo" di un ordine: info da /orderboard/late ({ level, statusName, ageMs, limitMs })
import { formatDuration } from './format';

export default {
	name: 'LateBadge',
	props: {
		info: { type: Object, default: null },
	},
	computed: {
		label() {
			return `${this.info.level === 'late' ? 'In ritardo' : 'Al limite'} ${formatDuration(this.info.ageMs, this.info.hoursOnly)}`;
		},
		title() {
			const f = ms => formatDuration(ms, this.info.hoursOnly);
			const limit = this.info.limitMs ? ` (limite ${f(this.info.limitMs)})` : '';
			const unit = this.info.hoursOnly ? ' lavorative' : '';
			return `Fermo in ${this.info.statusName} da ${f(this.info.ageMs)}${unit}${limit}`;
		},
	},
};
</script>
